// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToChainAfter, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { chain, UpdateBillTo } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateBillTo";

export const xValidateBillingAddress: typeof UpdateBillTo = async props => {
    const state = props.getState();
    const { isBillingAddressTheSameAsShipping, billingAddressFormState } = state.pages.onePageCheckout;

    if (!billingAddressFormState) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const billingAddressErrors = await awaitableValidate({
        address: props.parameter.billTo,
        validationRules: props.parameter.billTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.billToAddressFields,
    })(props.dispatch, props.getState);
    const isBillingAddressValid = Object.keys(billingAddressErrors).length === 0;

    props.dispatch({
        type: "Pages/OnePageCheckout/SetIsBillingAddressUpdateRequired",
        isBillingAddressUpdateRequired: !isBillingAddressValid,
    });

    // reset isShippingAddressUpdateRequired if it's same as billing
    if (isBillingAddressTheSameAsShipping && isBillingAddressValid) {
        props.dispatch({
            type: "Pages/OnePageCheckout/SetIsShippingAddressUpdateRequired",
            isShippingAddressUpdateRequired: !isBillingAddressValid,
        });
    }
};

addToChainAfter(chain, UpdateBillTo, xValidateBillingAddress);
